import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import * as nieuweSportclubModelsActions from "../../../actions/nieuweSportclubModelsActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import redirector from "../../../util/redirector";

import SporttakPageHelper from "./SporttakPageHelper";
import SporttakForm from "./SporttakForm";
import mergeDeep from "../../../util/mergeDeep.js";

class SporttakPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: {
                sporttakken: []
            },
            searchresults: [],
            sporttakFilterHasFocus: true,
            level: -1,
            searchLevel: -1,
            filter: '',
            totalSearchResults: -1,
            checkedSporttakken: [],
            unsavedCheckedSporttakken: [],
            showDeleteSporttakModal: false,
            sporttakToDelete: null
        };

        this.pageHelper = new SporttakPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    componentWillUnmount = () => {
        let model = mergeDeep({}, this.state.model);
        this.props.updateModel(model);
    };

    handleOnGoToNext = () => this.pageHelper.goToNext();
    handleOnGoToPrev = () => this.pageHelper.goToPrev();
    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnChangeFilter = (event) => this.pageHelper.changeFilter(event);
    handleOnIncreaseLevel = (currentlevel) => this.pageHelper.increaseLevel(currentlevel);
    handleOnIncreaseSearchLevel = (currentlevel) => this.pageHelper.increaseSearchLevel(currentlevel);
    handleOnSearch = () => this.pageHelper.search();
    handleOnDelete = (id) => this.pageHelper.onClickDelete(id);
    handleOnConfirmDeleteSporttak = () => this.pageHelper.confirmDeleteSporttakModal();
    handleOnCloseDeleteSporttakModal = () => this.pageHelper.closeDeleteSporttakModal();

    render() {
        const state = this.state;
        const model = state.model;
        const searchresults = state.searchresults;
        const sporttakFilterHasFocus = state.sporttakFilterHasFocus;
        const level = state.level;
        const filter = state.filter;
        const totalSearchResults = state.totalSearchResults;
        const checkedSporttakken = state.checkedSporttakken;
        const searchLevel = state.searchLevel;
        const unsavedCheckedSporttakken = state.unsavedCheckedSporttakken;
        const showDeleteSporttakModal = state.showDeleteSporttakModal;

        return (
            <SporttakForm
                goToNext={this.handleOnGoToNext}
                goToPrev={this.handleOnGoToPrev}
                model={model}
                searchresults={searchresults}
                sporttakFilterHasFocus={sporttakFilterHasFocus}
                onChange={this.handleOnChange}
                onChangeFilter={this.handleOnChangeFilter}
                onIncreaseLevel={this.handleOnIncreaseLevel}
                onIncreaseSearchLevel={this.handleOnIncreaseSearchLevel}
                level={level}
                searchLevel={searchLevel}
                filter={filter}
                onSearch={this.handleOnSearch}
                totalSearchResults={totalSearchResults}
                checkedSporttakken={checkedSporttakken}
                unsavedCheckedSporttakken={unsavedCheckedSporttakken}
                onDelete={this.handleOnDelete}
                confrimDeleteSporttak={this.handleOnConfirmDeleteSporttak}
                closeDeleteSporttakModal={this.handleOnCloseDeleteSporttakModal}
                showDeleteSporttakModal={showDeleteSporttakModal}
            />
        );
    }
}

SporttakPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        storeModel: state.nieuweSportclubModels.sporttak
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadNieuweSportclubSporttakkenPageLayout, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        updateModel: bindActionCreators(nieuweSportclubModelsActions.sporttakkenModelUpdate, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SporttakPage);